import React from 'react';
import classNames from 'classnames';

import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';

export class ListItem extends React.Component {
  static propTypes = listItemPropTypes;

  render() {
    const listItemClass = classNames(
      this.props.className,
      { dragging: this.props.isDragging }
    );
    return this.props.connectDragPreview(this.props.connectDropTarget(this.props.connectDragSource(
      <li className={listItemClass}>
        {this.props.children}
      </li>
    )));
  }
}

export default reorderableListItem(ListItem, 'listItem', {
  canDrag: (() => true),

  beginDrag(props) {
    return {
      index: props.index,
      listName: props.listName
    };
  }
});
